import React from "react";

interface ConfirmationModalProp {   
    modalTitle?: string;
    modalText?: string;
    onYesClick?: () => void;
    onCancelClick?: () => void;
}

export const ConfirmationModal = (props: ConfirmationModalProp) => {
    return (
        <>
            <div  className="modal show d-block"  role="dialog" style={{ backgroundColor: 'rgba(0, 0, 0, 0.5)' }}>
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">{"New Comment"}</h5>                           
                        </div>
                        <div className="modal-body">
                            <p>{props.modalText}</p>
                        </div>
                        <div className="modal-footer">
                            <button type="button" onClick={props.onYesClick} className="btn btn-primary">
                                Yes
                            </button>
                            <button type="button" className="btn btn-secondary" onClick={props.onCancelClick} data-dismiss="modal">
                                Cancel
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};
